/**
 * @generated SignedSource<<24fd3ca11b7f1a2bd127c812df1ca927>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceGroupEditMain_serviceGroup$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "ServiceGroupEditMain_serviceGroup";
};
export type ServiceGroupEditMain_serviceGroup$key = {
  readonly " $data"?: ServiceGroupEditMain_serviceGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupEditMain_serviceGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceGroupEditMain_serviceGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "ServiceGroup",
  "abstractKey": null
};

(node as any).hash = "64934bbb7bd8e849049e8621b51f30c9";

export default node;
